<template>
  <el-container>
    <el-main v-loading="loading" style="overflow:auto;">
      <div v-if="bull_select === ''">
        <el-row>
          <div style="min-width:132px;">
            <el-button color="#EEEEEC" class="operation-btn" @click="newEntry()">
              <el-icon style="color: #383838; padding-right: 1em;">
                <IconPlus />
              </el-icon>新規登録
            </el-button>
          </div>
          <div class="font_18" style="margin-left:25%; display:grid; align-items: center; text-align:center;">
            <span>人工授精で登録する種雄牛情報を登録できます。</span>
          </div>
        </el-row>
        <div v-if="tableData.length != 0">
          <el-table :data="tableData" height="620" stripe @row-click="selectBullInfo"
            style="margin-top:32px;min-width:400px;">
            <el-table-column label="" :width="headerWidth" />
            <el-table-column style="background: #EEEEEC;" prop="name" label="名前">
            </el-table-column>
            <el-table-column prop="no" label="個体識別番号">
            </el-table-column>
            <el-table-column prop="breed" label="種類">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="!loading & (tableData.length == 0)">
          <el-row class="width100">
            <el-row class="width100" style="justify-content:center;margin-top:20%;">
              <p class="font_18 font_bold">登録されている種雄牛がいません</p>
            </el-row>
          </el-row>
        </div>
      </div>
      <!-- 詳細表示 -->
      <div v-if="bull_select !== '' & bull_select !== '新規登録' & !bull_edit">
        <div style="margin-top: 44px;">
          <el-button color="#EEEEEC" class="operation-btn" type="primary" @click="bull_edit = true">
            <el-icon style="color: #383838; padding-right: 1em;">
              <IconPencil />
            </el-icon>編集
          </el-button>
        </div>
        <el-row>
          <div
            style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;min-height:150px;margin-top:32px;min-width:270px;">
            <el-row class="title-area">個体情報</el-row>
            <el-row class="body-area" style="margin-top: 24px;">
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row class="bull-input">名前</el-row>
                <el-row>
                  <p class="font-bold bull-input long-string">{{ bull_name }}</p>
                </el-row>
              </el-col>
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row>個体識別番号</el-row>
                <el-row>
                  <p class="font-bold">{{ bull_number }}</p>
                </el-row>
              </el-col>
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row>種類</el-row>
                <el-row>
                  <p class="font-bold">{{ bull_breed }}</p>
                </el-row>
              </el-col>
              <el-col :span="12" style="margin-top: 0px;"></el-col>
            </el-row>
          </div>
        </el-row>
        <el-row>

          <div
            style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;margin-top:15px;min-width:270px;padding-bottom: 32px;">
            <el-row class="title-area">血統
              <el-button round color="#EEEEEC" size="small" style="margin-left:2em;color:#383838;" type="primary"
                @click="isAbbreviationDisplay = !isAbbreviationDisplay">
                <el-icon style="color: #383838; text-align: center;">
                  <IconArrowDownBold v-if="isAbbreviationDisplay" />
                  <IconArrowUpBold v-if="!isAbbreviationDisplay" />
                </el-icon>
              </el-button>
            </el-row>
            <el-row v-if="isAbbreviationDisplay" class="body-area-one-line">
              <el-col :span="4" class="v-center" style="min-width:234px;">
                <el-row>
                  <el-col :span="8" class="v-center">父牛</el-col>
                  <el-col :span="16"><span class="font-bold long-string">{{ fa }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" class="v-center" style="padding:0px 44px 0 44px;min-width:211px;">
                <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
              </el-col>
              <el-col :span="4" class="v-center" style="min-width:234px;">
                <el-row>
                  <el-col :span="8" class="v-center">祖父</el-col>
                  <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" class="v-center" style="padding:4px 44px 0 44px;min-width:211px;">
                <img src="@/assets/family_line2.png" title="血統線2" style="width:136px;margin-left: 15px;" />
              </el-col>
              <el-col :span="4" class="v-center" style="min-width:234px;">
                <el-row>
                  <el-col :span="8" class="v-center">曽祖父</el-col>
                  <el-col :span="16"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="!isAbbreviationDisplay" class="body-area">
              <el-col :span="4" class="v-center" style="min-width:234px;">
                <el-row>
                  <el-col :span="8" class="v-center">父牛</el-col>
                  <el-col :span="16"><span class="font-bold long-string">{{ fa }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" id="father_canvas_div" class="v-center" style="padding:0px 44px 0 44px;min-width:211px;">
                <pedigree-canvas v-if="fatherCanvasEnv" :width="canvasWidth" :height="fatherCanvasHeight"
                  :fCowHeight="ffCowHeight" :mCowHeight="fmCowHeight" />
              </el-col>
              <el-col :span="14" id="father_cow" style="min-width:170px;">
                <el-row id="ff_cow" v-if="!r_side_split">
                  <el-col :span="8" class="v-center" style="min-width:170px;">
                    <el-row>
                      <el-col :span="8" class="v-center">祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="min-width:224px;">
                    <el-row>
                      <el-col :span="8" class="v-center">曽祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_fa_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row id="fm_cow" v-if="!r_side_split">
                  <el-col :span="8" class="v-center" style="min-width:170px;">
                    <el-row style="padding-top: 64px;">
                      <el-col :span="8" class="v-center">祖母</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_mo }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8" class="v-center" style="padding:65px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="min-width:224px;">
                    <el-row style="padding-top: 61px;">
                      <el-col :span="8" class="v-center">曽祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="r_side_split">
                  <el-col :span="8" style="min-width:170px;">
                    <el-row id="ff_cow">
                      <el-col :span="8" class="v-center">祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_fa }}</span></el-col>
                    </el-row>
                    <el-row id="fm_cow" style="padding-top: 64px;">
                      <el-col :span="8" class="v-center">祖母</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ fa_mo }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="r_side_split && !isAbbreviationDisplay">
              <el-col :span="20" style="min-width:260px;">
                <el-row>
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                  <el-col :span="8"><span class="font-bold long-string">{{ fa_fa_fa }}</span></el-col>
                </el-row>
                <el-row style="padding-top: 61px;">
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                  <el-col :span="8"><span class="font-bold long-string">{{ fa_mo_fa }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="4" style="min-width:170px;">
              </el-col>
            </el-row>
            <el-row v-if="!isAbbreviationDisplay" class="body-area" style="padding-top:28px;">
              <el-col :span="4" class="v-center" style="min-width:234px;">
                <el-row>
                  <el-col :span="8" class="v-center">母牛</el-col>
                  <el-col :span="16"><span class="font-bold long-string">{{ mo }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" id="mother_canvas_div" class="v-center" style="padding:0px 44px 0 44px;min-width:211px;">
                <pedigree-canvas v-if="motherCanvasEnv" :width="canvasWidth" :height="motherCanvasHeight"
                  :fCowHeight="mfCowHeight" :mCowHeight="mmCowHeight" />
              </el-col>
              <el-col :span="14" style="min-width:170px;">
                <el-row id="mf_cow" v-if="!r_side_split">
                  <el-col :span="8" class="v-center" style="min-width:170px;">
                    <el-row>
                      <el-col :span="8" class="v-center">祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="min-width:224px;">
                    <el-row>
                      <el-col :span="8" class="v-center">曽祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_fa_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row id="mm_cow" v-if="!r_side_split">
                  <el-col class="v-center" :span="8" style="min-width:170px;">
                    <el-row style="padding-top: 64px;">
                      <el-col :span="8" class="v-center">祖母</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_mo }}</span></el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8" class="v-center" style="padding:65px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="min-width:224px;">
                    <el-row style="padding-top: 64px;">
                      <el-col :span="8" class="v-center">曽祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="r_side_split && !isAbbreviationDisplay">
                  <el-col :span="8" style="min-width:170px;">
                    <el-row id="mf_cow">
                      <el-col :span="8" class="v-center">祖父</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_fa }}</span></el-col>
                    </el-row>
                    <el-row id="mm_cow" style="padding-top: 64px;">
                      <el-col :span="8" class="v-center">祖母</el-col>
                      <el-col :span="16"><span class="font-bold long-string">{{ mo_mo }}</span></el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="r_side_split && !isAbbreviationDisplay">
              <el-col :span="20" style="min-width:260px;">
                <el-row>
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                  <el-col :span="8"><span class="font-bold long-string">{{ mo_fa_fa }}</span></el-col>
                </el-row>
                <el-row style="padding-top: 61px;">
                  <el-col :span="8" class="v-center" style="padding:4px 44px 0 44px;min-width:250px;">
                    <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 15px;" />
                  </el-col>
                  <el-col :span="8" class="v-center" style="max-width: 100px;">曽祖父</el-col>
                  <el-col :span="8"><span class="font-bold long-string">{{ mo_mo_fa }}</span></el-col>
                </el-row>
              </el-col>
              <el-col :span="4" style="min-width:170px;">
              </el-col>
            </el-row>
          </div>
        </el-row>
      </div>
      <!-- 編集中 -->
      <div v-if="bull_edit">
        <el-row>
          <div
            style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;height:auto;padding-bottom:46px;margin-top:15px;min-width:325px;">
            <el-row class="title-area">個体情報</el-row>
            <el-row class="body-area" style="margin-top: 24px;">
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row class="bull-input">名前</el-row>
                <el-row><el-input :maxlength="maxLength" placeholder="" v-model="bull_name" class="bull-input"
                    style="width:180px" /></el-row>
              </el-col>
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row>個体識別番号</el-row>
                <el-row><el-input :maxlength="10" placeholder="" v-model="bull_number" style="width:180px" /></el-row>
              </el-col>
              <el-col :span="4" style="margin-top:0px;min-width:200px;">
                <el-row>種類</el-row>
                <el-row>
                  <el-select id="bull_breed" placeholder="" v-model="bull_breed" style="width:180px">
                    <el-option v-for="cow_kind in this.cow_kinds_select" :key="cow_kind.id" :label="cow_kind.kind"
                      :value="cow_kind.kind" />
                  </el-select>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-row>
        <el-row>
          <div
            style="color:#383838;background:#F8F8F7;border-radius:8px;width:100%;height:auto;margin-top:15px;padding-bottom:15px;">
            <el-row class="title-area">血統
              <el-button round color="#EEEEEC" size="small" style="margin-left:2em;color:#383838;" type="primary"
                @click="isAbbreviationDisplay = !isAbbreviationDisplay">
                <el-icon style="color: #383838; text-align: center;">
                  <IconArrowDownBold v-if="isAbbreviationDisplay" />
                  <IconArrowUpBold v-if="!isAbbreviationDisplay" />
                </el-icon>
              </el-button>
            </el-row>
            <el-row v-if="isAbbreviationDisplay" class="body-area-one-line">
              <el-col :span="4" class="v-center" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">父牛</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" class="v-center" style="padding:0px 44px 0 44px;min-width:235px;">
                <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" class="v-center" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" class="v-center" style="padding:4px 44px 0 44px;min-width:235px;">
                <img src="@/assets/family_line2.png" title="血統線" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" class="v-center" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">曽祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_mo_fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="!isAbbreviationDisplay" class="body-area">
              <el-col :span="4" style="padding-top:48px;min-width:220px;">
                <el-row>
                  <el-col :span="8">父牛</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" style="padding:10px 44px 0 44px;min-width:235px;">
                <img src="@/assets/pedigree_line1.png" title="牛画像" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa_fa" style="width:180px" /></el-col>
                </el-row>
                <el-row style="padding-top: 70px;">
                  <el-col :span="8">祖母</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa_mo" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" style="padding:10px 44px 0 44px;min-width:235px;">
                <img src="@/assets/pedigree_line2.png" title="牛画像" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">曽祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa_fa_fa" style="width:180px" /></el-col>
                </el-row>
                <el-row style="padding-top: 70px;">
                  <el-col :span="8">曽祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="fa_mo_fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="!isAbbreviationDisplay" class="body-area" style="padding-top:28px;">
              <el-col :span="4" style="padding-top:48px;min-width:220px;">
                <el-row>
                  <el-col :span="8">母牛</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" style="padding:10px 44px 0 44px;min-width:235px;">
                <img src="@/assets/pedigree_line1.png" title="牛画像" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_fa" style="width:180px" /></el-col>
                </el-row>
                <el-row style="padding-top: 70px;">
                  <el-col :span="8">祖母</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_mo" style="width:180px" /></el-col>
                </el-row>
              </el-col>
              <el-col :span="5" style="padding:10px 44px 0 44px;min-width:235px;">
                <img src="@/assets/pedigree_line2.png" title="牛画像" style="width:136px;margin-left: 45px;" />
              </el-col>
              <el-col :span="4" style="min-width:220px;">
                <el-row>
                  <el-col :span="8">曽祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_fa_fa" style="width:180px" /></el-col>
                </el-row>
                <el-row style="padding-top: 70px;">
                  <el-col :span="8">曽祖父</el-col>
                  <el-col :span="16"><el-input :maxlength="maxLength" v-model="mo_mo_fa" style="width:180px" /></el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-row>
      </div>
    </el-main>
    <el-footer style="background:white;paddingTop:4px;">
      <div style="width:100%;overflow:auto;">
        <el-row v-if="bull_select !== '' & bull_select !== '新規登録' & !bull_edit" style="justify-content:center;">
          <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
            @click="bull_select = ''">戻る</el-button>
        </el-row>
        <el-row v-if="bull_edit & bull_select === '新規登録'" style="justify-content:center;">
          <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
            @click="editCancel()">キャンセル</el-button>
          <el-button class="button-style" color="#ffdf5e" style="width:214px;" round type="primary"
            @click="bullInfoEntry()">保存</el-button>
        </el-row>
        <el-row v-if="bull_edit & bull_select !== '新規登録'" style="justify-content:right;">
          <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
            @click="editCancel()">キャンセル</el-button>
          <el-button class="button-style" color="#ffdf5e" style="width:214px;" round type="primary"
            @click="bullInfoEntry()">保存</el-button>
          <el-button class="button-style-short" color="#EEEEEC" round type="primary" @click="bullInfoDataDelete()"
            style="margin-left:25%;margin-right:5%;">
            <el-icon style="color: #383838; padding-right: 0.5em;">
              <IconTrash />
            </el-icon>削除
          </el-button>
        </el-row>
      </div>
    </el-footer>
  </el-container>
</template>
<script>
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from '../views/js/cognito';
import AWSAPI from '../views/js/aws-api';
import { ElMessage } from 'element-plus';
import ConstParam from '../views/js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'
import PedigreeCanvas from './PedigreeCanvas.vue';

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

// 数値文字列判定
const isNumberString = n => typeof n === "string" && !isNaN(n);

export default {
  components: { PedigreeCanvas },
  props: ['bullId', 'farmerId', 'edit', 'bullData', 'modeDialog', 'headerWidth'],
  emits: ['dialogClose', 'selectBull'],
  data() {
    return {
      isAbbreviationDisplay: true,
      r_side_split: false,
      ffCowHeight: 0,
      fmCowHeight: 0,
      mfCowHeight: 0,
      mmCowHeight: 0,
      redrawTimer: 0,
      fatherCanvasEnv: false,
      motherCanvasEnv: false,
      canvasWidth: 133,
      fatherCanvasHeight: 66,
      motherCanvasHeight: 66,
      interval_id: null,
      IconPlus: shallowRef(icons.IconPlus),
      IconPencil: shallowRef(icons.IconPencil),
      IconTrash: shallowRef(icons.IconTrash),
      IconArrowDownBold: shallowRef(icons.IconArrowDownBold),
      IconArrowUpBold: shallowRef(icons.IconArrowUpBold),
      mode_dialog: false,
      maxLength: ConstParam.maxLength,
      loading: false,
      bull_edit: false,
      bull_select: "",
      bullsData: [],
      orgTableData: [],
      tableData: [],
      cow_kinds: ConstParam.cow_kinds,
      cow_kinds_select: ConstParam.cow_kinds_select,
      // farmer_id: "",
      search_text: "",
      // 個体情報
      bull_id: "",
      bull_name: "",
      bull_number: "",
      bull_breed: "",
      // 血統
      fa: "",
      fa_fa: "",
      fa_mo: "",
      fa_fa_fa: "",
      fa_mo_fa: "",
      mo: "",
      mo_fa: "",
      mo_mo: "",
      mo_fa_fa: "",
      mo_mo_fa: ""
    }
  },
  mounted() {
    this.mode_dialog = this.modeDialog;
    this.bull_select = this.bullId;
    this.bullsData = this.bullData;
    if (this.edit) {
      this.bull_edit = true;
      this.bullInfoDataSet(this.bull_select);
    }
    this.setTimer();
  },
  beforeUnmount() {
    clearInterval(this.interval_id);
  },
  methods: {
    setTimer() {
      let timeOut = 100; // 100ms毎
      this.interval_id = setInterval(function () {
        this.getPedigreeLineInfo();
        this.redrawTimer--;
        if (this.redrawTimer == 0) {
          this.fatherCanvasEnv = true
          this.motherCanvasEnv = true
        } else if (this.redrawTimer < 0) {
          this.redrawTimer = 0;
        }
      }.bind(this), timeOut);
    },
    getPedigreeLineInfo() {
      if (
        this.bull_select !== '' &&
        this.bull_select !== '新規登録' &&
        !this.bull_edit
      ) {
        try {
          let canvasHeightOffset = -16
          let right_side_split = 750
          // 父牛系統
          let f_side_width = document.getElementById('father_cow').clientWidth
          if (f_side_width < right_side_split) {
            this.r_side_split = true
          } else {
            this.r_side_split = false
          }
          this.ffCowHeight = document.getElementById('ff_cow').clientHeight
          this.fmCowHeight = document.getElementById('fm_cow').clientHeight
          let tempFatherDivHeight = this.ffCowHeight + this.fmCowHeight
          if ((tempFatherDivHeight + canvasHeightOffset) != this.fatherCanvasHeight) {
            this.fatherCanvas = null
            this.fatherCanvasEnv = false
            this.fatherCanvasHeight = tempFatherDivHeight + canvasHeightOffset
            this.redrawTimer = 2
          }
          // 母牛系統
          this.mfCowHeight = document.getElementById('mf_cow').clientHeight
          this.mmCowHeight = document.getElementById('mm_cow').clientHeight
          let tempMotherDivHeight = this.mfCowHeight + this.mmCowHeight
          if ((tempMotherDivHeight + canvasHeightOffset) != this.motherCanvasHeight) {
            this.motherCanvas = null
            this.motherCanvasEnv = false
            this.motherCanvasHeight = tempMotherDivHeight + canvasHeightOffset
            this.redrawTimer = 2
          }
        } catch (e) {
          return
        }
      }
    },
    set_bulls_data() {
      // let tempTable = [];
      this.tableData = [];
      let tempBreed = 2;
      for (let idx = 0; idx < this.bullsData.length; idx++) {
        if ("bull_breed" in this.bullsData[idx]) {
          tempBreed = this.bullsData[idx]['bull_breed'];
        }
        let tempData = {
          "id": this.bullsData[idx]['bull_id'],
          "no": this.bullsData[idx]['bull_number'],
          "name": this.bullsData[idx]['bull_name'],
          "breed": this.cow_kinds[tempBreed],
          "pedigree": this.bullsData[idx]['pedigree']
        }
        // tempTable.push(tempData);
        this.tableData.push(tempData);
      }
      // this.tableData = tempTable;
      this.orgTableData = this.tableData;
    },
    bullInfoDataSet(bull_id) {
      // 初期化
      this.bull_name = "";
      this.bull_number = "";
      this.bull_breed = "黒毛和牛";
      this.fa_fa_fa = "";
      this.fa_mo_fa = "";
      this.mo = "";
      this.fa_fa = "";
      this.mo_fa_fa = "";
      this.fa = "";
      this.mo_fa = "";
      this.fa_mo = "";
      this.mo_mo = "";
      this.mo_mo_fa = "";
      if (bull_id === "新規登録") {
        // 新規データ設定のため処理終了
        return;
      }
      let idx = this.selectBullsDataID(bull_id);
      if (idx == -1) {
        this.bull_select = "";
        this.bull_edit = false;
        // this.get_bulls();
        return;
      }
      // 取得済みデータのセット
      // 個体情報
      if ("bull_name" in this.bullsData[idx]) { this.bull_name = this.bullsData[idx]["bull_name"] }
      if ("bull_number" in this.bullsData[idx]) { this.bull_number = this.bullsData[idx]["bull_number"] }
      if ("bull_breed" in this.bullsData[idx]) { this.bull_breed = this.cow_kinds[this.bullsData[idx]["bull_breed"]] } else { this.bull_breed = this.cow_kinds[this.cow_kinds.length - 1] }
      if ("pedigree" in this.bullsData[idx]) {
        if ("fa_fa_fa" in this.bullsData[idx]["pedigree"]) { this.fa_fa_fa = this.bullsData[idx]["pedigree"]["fa_fa_fa"] }
        if ("fa_mo_fa" in this.bullsData[idx]["pedigree"]) { this.fa_mo_fa = this.bullsData[idx]["pedigree"]["fa_mo_fa"] }
        if ("mo" in this.bullsData[idx]["pedigree"]) { this.mo = this.bullsData[idx]["pedigree"]["mo"] }
        if ("fa_fa" in this.bullsData[idx]["pedigree"]) { this.fa_fa = this.bullsData[idx]["pedigree"]["fa_fa"] }
        if ("mo_fa_fa" in this.bullsData[idx]["pedigree"]) { this.mo_fa_fa = this.bullsData[idx]["pedigree"]["mo_fa_fa"] }
        if ("fa" in this.bullsData[idx]["pedigree"]) { this.fa = this.bullsData[idx]["pedigree"]["fa"] }
        if ("mo_fa" in this.bullsData[idx]["pedigree"]) { this.mo_fa = this.bullsData[idx]["pedigree"]["mo_fa"] }
        if ("fa_mo" in this.bullsData[idx]["pedigree"]) { this.fa_mo = this.bullsData[idx]["pedigree"]["fa_mo"] }
        if ("mo_mo" in this.bullsData[idx]["pedigree"]) { this.mo_mo = this.bullsData[idx]["pedigree"]["mo_mo"] }
        if ("mo_mo_fa" in this.bullsData[idx]["pedigree"]) { this.mo_mo_fa = this.bullsData[idx]["pedigree"]["mo_mo_fa"] }
      }
    },
    selectBullsDataID(bull_id) {
      let ret = -1;
      for (let idx = 0; idx < this.bullsData.length; idx++) {
        if ("bull_id" in this.bullsData[idx] && this.bullsData[idx]["bull_id"] === bull_id) {
          ret = idx;
          break;
        }
      }
      return ret;
    },
    selectBullInfo(val) {
      this.isAbbreviationDisplay = true
      this.fatherCanvasEnv = false
      this.motherCanvasEnv = false
      this.fatherCanvasHeight = 66
      this.motherCanvasHeight = 66
      this.bull_select = val['id']
      this.bullInfoDataSet(this.bull_select)
    },
    delete_bull: async function (delBullCode) {
      this.loading = true;
      await AWSAPI.deleteBull(this.farmerId, delBullCode)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage("種雄牛を削除しました。", "success");
          }
          this.get_bull_data();
        });
    },
    newEntry() {
      // 新規登録
      this.isAbbreviationDisplay = true;
      this.bull_select = "新規登録";
      this.bullInfoDataSet(this.bull_select);
      this.bull_edit = true;
    },
    editCancel() {
      // 変更キャンセル
      if (this.mode_dialog) {
        this.$emit("dialogClose", "bullDialog");
        return;
      }
      this.bull_edit = false;
      if (this.bull_select !== "新規登録") {
        this.bullInfoDataSet(this.bull_select);
      } else {
        this.bull_select = "";
      }
    },
    bullInfoEntry() {
      // 登録・更新
      if (!this.itemCheck()) {
        return;
      }
      let message = "種雄牛情報を登録・更新しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '登録・更新',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        this.bullInfoDataEntry(this.bull_select);
      }).catch(() => {
        return
      });
    },
    bullInfoDataEntry: async function (bull_id) {
      // 初期化
      // データのセット
      let tempBullName = this.bull_name;
      if (this.bull_name === "") {
        // 名前未入力時は耳標・拡大4桁を名前に入力する
        tempBullName = this.bull_number.substring(5, 9);
      }
      let tempPedigree = {
        "fa": this.fa,
        "fa_fa": this.fa_fa,
        "fa_mo": this.fa_mo,
        "fa_fa_fa": this.fa_fa_fa,
        "fa_mo_fa": this.fa_mo_fa,
        "mo": this.mo,
        "mo_fa": this.mo_fa,
        "mo_mo": this.mo_mo,
        "mo_fa_fa": this.mo_fa_fa,
        "mo_mo_fa": this.mo_mo_fa
      }
      let tempMessage = "種雄牛情報を";
      if (this.bull_name === "") {
        tempMessage = "名前を「" + tempBullName + "」で";
      }
      if (bull_id === "新規登録") {
        await AWSAPI.addBull(
          this.farmerId,
          tempBullName,
          this.bull_number,
          this.cow_kinds.indexOf(this.bull_breed),
          tempPedigree
        )
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.bull_select = "";
              this.bull_edit = false;
              this.viewMessage(tempMessage + "登録しました。", "success");
              if (!this.mode_dialog) {
                this.get_bulls();
              } else {
                this.$emit("selectBull", res.data.data[0].bull_name, res.data.data[0].bull_id)
                this.$emit("dialogClose", "bullDialog");
                return;
              }
            }
          });
      } else {
        await AWSAPI.updateBull(
          bull_id,
          tempBullName,
          this.bull_number,
          this.cow_kinds.indexOf(this.bull_breed),
          tempPedigree
        )
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.bull_select = "";
              this.bull_edit = false;
              this.viewMessage(tempMessage + "更新しました。", "success");
              if (!this.mode_dialog) {
                this.get_bulls();
              } else {
                this.$emit("dialogClose", "bullDialog");
                return;
              }
            } else {
              if (!this.mode_dialog) {
                this.get_bulls();
              }
            }
          });
      }
    },
    itemCheck() {
      if (this.bull_name === "") {
        this.viewMessage("名前が入力されておりません。", "error");
        return false;
      }
      if (
        this.bull_number !== "" &&
        (!isNumberString(this.bull_number) || this.bull_number.length != 10)
      ) {
        this.viewMessage(ConstParam.number_error_message, "error");
        return false;
      }
      return true;
    },
    bullInfoDataDelete: async function () {
      // 初期化
      let message = "種雄牛を削除しますか？";
      this.$confirm(message, "", {
        confirmButtonText: '削除',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        AWSAPI.deleteBull(this.bull_select)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.viewMessage("種雄牛を削除しました。", "success");
              this.bull_select = "";
              this.bull_edit = false;
              this.get_bulls();
            }
          });
      }).catch(() => {
        return
      });
    },
    get_bulls: async function () {
      // 種雄牛データ取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getBulls(this.farmerId)
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.bullsData = res['data']['data'];
          }
        });
    },
    viewMessage(message, status) {
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    }
  },
  watch: {
    bullData: function () {
      this.bullsData = this.bullData;
      if (this.edit) {
        this.bull_edit = true;
        this.bullInfoDataSet(this.bull_select);
      }
    },
    bullsData: function () {
      this.set_bulls_data();
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.bull-input {
  padding-left: 1em;
}

.el-row {
  justify-content: left;
}

.title-area {
  padding: 12px 0 0 24px;
  font-size: 18px;
}

.body-area {
  padding: 0 36px 0 36px;
}

.body-area-one-line {
  padding: 36px 36px 0 36px;
}

.font-bold {
  font-weight: bold;
}

.long-string {
  overflow-wrap: anywhere;
}

.v-center {
  align-content: center;
}
</style>
